// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader{
  font-size: 48px;
  color: #FFF;
  display: inline-block;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 400;
  position: relative;
}
.loader:after{
  content: 'Alfred...';
  position: relative;
  z-index: 5;
}
.loader:before{
  content: '';
  height: 6px;
  border: 1px solid;
  border-radius: 10px;
  width: 100%;
  position: absolute;
  bottom: 0px;
  background: linear-gradient(50.6deg, #005FF9 2.95%, #B363FE 46.88%, #8FDBFF 97.72%), linear-gradient(0deg, #FFFFFF, #FFFFFF) no-repeat;
  background-size: 0% auto;
  animation: 10s lineGrow linear infinite;
}

@keyframes lineGrow {to {  background-size: 100% auto}}`, "",{"version":3,"sources":["webpack://./src/components/loading/css/loading.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sIAAsI;EACtI,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA,qBAAqB,MAAM,0BAA0B,CAAC","sourcesContent":[".loader{\n  font-size: 48px;\n  color: #FFF;\n  display: inline-block;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: 400;\n  position: relative;\n}\n.loader:after{\n  content: 'Alfred...';\n  position: relative;\n  z-index: 5;\n}\n.loader:before{\n  content: '';\n  height: 6px;\n  border: 1px solid;\n  border-radius: 10px;\n  width: 100%;\n  position: absolute;\n  bottom: 0px;\n  background: linear-gradient(50.6deg, #005FF9 2.95%, #B363FE 46.88%, #8FDBFF 97.72%), linear-gradient(0deg, #FFFFFF, #FFFFFF) no-repeat;\n  background-size: 0% auto;\n  animation: 10s lineGrow linear infinite;\n}\n\n@keyframes lineGrow {to {  background-size: 100% auto}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
